export const PURCHASE_REASON = "purchase";

export function buildLoginRedirect(nextPath = "/", reason = "") {
  const params = new URLSearchParams();
  if (nextPath) params.set("next", nextPath);
  if (reason) params.set("reason", reason);
  const qs = params.toString();
  return qs ? `/login?${qs}` : "/login";
}
